<template>
  <v-dialog
    content-class="dialogPopUp"
    v-model="internalVisible"
    @click:outside="close()"
    @keydown.esc="close()"
    persistent
    max-width="1324px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5"> {{ $t("router_titles.expired_depot") }} </span>
      </v-card-title>
      <v-card-text @click="modify_data = true">
        <v-row class="mt-4 mb-4">
          <v-data-table
            fixed-header
            :footer-props="{
              'items-per-page-options': dataTableOptions,
            }"
            :headers="depositHeader"
            :hide-default-footer="true"
            :items="expiredDepots"
            :items-per-page="itemsPerPage"
            :options.sync="options"
            :sort-by="sortBy"
            :loading-text="this.$t('loading')"
            class="elevation-0"
            item-key="id"
            height="29vh"
            style="width: 100%"
            hide-no-data
          >
            <template v-slot:item="{ item }">
              <tr
                :class="item == selectedDepot ? 'bg-selected-table-row' : 'bg-white'"
                @click="selectDepot(item)"
                v-if="item.deleted_at ? isHistory : true"
              >
                <td></td>
                <td
                  :id="item.id"
                  :data="
                    selectedDepot && selectedDepot.id == item.id
                      ? highlightRow(item.id)
                      : ''
                  "
                >
                  <span v-if="item.status.key">
                    <DepotStatus :status-key="item.status.key" />
                  </span>
                </td>
                <td>
                  {{ item.localisation }}
                </td>
                <td>
                  {{ formatDateTime(item.created_at) }}
                </td>
                <td>
                    {{ formatDate(item.expiration_date) }}
                    <span style="color: red" v-if="item.expired_ago > 0">
                        <strong>({{ formatDays(item.expired_ago) }})</strong>
                    </span>
                </td>
                <td>
                  {{ formatDate(item.requested_out_for) }}
                </td>
                <td>
                  <template v-if="isHistory">
                    {{ formatDateTime(item.deleted_at) }}
                  </template>
                </td>
                <td align="right">
                  <v-icon
                    v-if="checkIfSomeErrorInDepot(item.details)"
                    color="error"
                  >
                    mdi-fridge-alert
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <span class="pr-4">
              <v-icon class="mb-2 mr-3 tyre-hotel-heading">
                mdi-account
              </v-icon>
              <span class="tyre-hotel-heading">{{
                $t("tyre_hotel.deposit_details.text")
              }}</span>
            </span>
            <v-data-table
              fixed-header
              :footer-props="{
                'items-per-page-options': dataTableOptions,
              }"
              :hide-default-footer="true"
              :headers="depositDeatilsHeader"
              :items="selectedDepotForSubTable"
              :items-per-page="itemsPerPage"
              :options.sync="options"
              :sort-by="sortBy"
              :loading-text="this.$t('loading')"
              class="elevation-0"
              item-key="id"
              height="32vh"
              style="width: 100%"
            >
              <template v-slot:item="{ item }">
                <tr
                  :class="
                    item.article_status && item.article_status.key == 'damaged'
                      ? 'damaged-row'
                      : ''
                  "
                >
                  <td>
                    <v-checkbox
                      :color="
                        item.article_status &&
                        item.article_status.key == 'damaged'
                          ? '#ff5252'
                          : 'black'
                      "
                      class="ma-0 mt-n1"
                      v-model="item.checked"
                      hide-details="auto"
                    ></v-checkbox>
                  </td>
                  <td>
                    <span v-if="item.position && item.position.id == 10281000">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-cancel
                      </v-icon>
                      {{ $t("tyre_hotel.position.no_position_shorthand") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281001">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-top-right-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.top_right_shorthand") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281002">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-top-left-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.top_left_shorthand") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281003">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-bottom-right-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.bottom_right_shorthand") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281004">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-bottom-left-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.bottom_left_shorthand") }}
                    </span>
                    <!-- Second Tyres -->
                    <span v-if="item.position && item.position.id == 10281006">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-top-right-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.top_right_shorthand_2") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281007">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-top-left-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.top_left_shorthand_2") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281008">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-bottom-right-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.bottom_right_shorthand_2") }}
                    </span>
                    <span v-if="item.position && item.position.id == 10281009">
                      <v-icon
                        :color="
                          item.article_status &&
                          item.article_status.key == 'damaged'
                            ? '#ff5252'
                            : 'black'
                        "
                      >
                        mdi-arrow-bottom-left-bold-box
                      </v-icon>
                      {{ $t("tyre_hotel.position.bottom_left_shorthand_2") }}
                    </span>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.article.title_description[0].description }}
                    </template>
                    <template v-else>
                      {{ item.article_name }}
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.article.property.property_03 }}
                    </template>
                    <template v-else>
                      <!--  -->
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.article.property.property_04 }}
                    </template>
                    <template v-else>
                      <!--  -->
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.article.property.property_05 }}
                    </template>
                    <template v-else>
                      <!--  -->
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.article.property.property_06 }}
                    </template>
                    <template v-else>
                      <!--  -->
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.article.property.property_07 }}
                    </template>
                    <template v-else>
                      <!--  -->
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.mm }}
                    </template>
                    <template v-else>
                      {{ item.mm }}
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.couple }}
                    </template>
                    <template v-else>
                      {{ item.couple }}
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.pressure }}
                    </template>
                    <template v-else>
                      {{ item.pressure }}
                    </template>
                  </td>
                  <td>
                    <template v-if="item.article_id">
                      {{ item.dot }}
                    </template>
                    <template v-else>
                      {{ item.dot }}
                    </template>
                  </td>
                  <td>
                    <span v-if="item.rimtype">
                      {{ item.rimtype.value }}
                    </span>
                  </td>
                  <td>
                    <v-icon v-if="item.is_with_hubcaps == 1" color="green">
                      mdi-check
                    </v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pr-2">
        <v-spacer></v-spacer>
        <v-btn class="px-4" color="grey lighten-2" @click="close()">
          {{ $t("tyre_hotel.add_modify_tyre.cancel") }}
          <v-icon dark right> mdi-keyboard-return </v-icon>
        </v-btn>
        <v-btn class="px-4" color="success" @click="addItToDocument()">
          {{ $t("expired_depots.add_to_document") }}
          <v-icon dark right> mdi-content-save </v-icon>
        </v-btn>
      </v-card-actions>
      <confirmation-model
            v-if="confirmationDialog"
            :showDialog.sync="confirmationDialog"
            :openedForOperation.sync="confirmationDialogOperation"
            :text.sync="confirmationDialogConfirmationText"
            :checkboxText.sync="confirmationDialogReCheckBoxConfirmationText"
            :trueText.sync="confirmationDialogTrueText"
            :falseText.sync="confirmationDialogFalseText"
            @buttonClicked="confirmationButtonClicked"
      ></confirmation-model>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.v-dialog__content--active {
  z-index: 9999998 !important; /* Ensure this is lower than the .dialogPopUp */
}
</style>
<script>
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import { validationMixin } from "vuelidate";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";
import DepotStatus from "@/components/TyreHotel/DepotStatus.vue";
import ConfirmationModel from "@/components/ConfirmationModel";
import _ from "lodash";

export default {
  name: "DepotOut",
  mixins: [validationMixin],
  components: {
    DepotStatus,
    "confirmation-model": ConfirmationModel,
  },
  validations: {},
  props: {
    value: [Boolean],
    modelData: [Object],
    vehicle_id: [Number],
  },
  data() {
    return {
      internalVisible: this.value,
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      expiredDepots: [],
      modify_stock_dialog: true,
      autocompleteValueLocal: "off",
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      modify_data: false,
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      isHistory: false,
      selected_vehicle: {},
      depot: [],
      page: 1,
      lastPage: null,
      totalItems: null,
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE_OPTIONS[0],
      sortBy: "expiration_date",
      sortDesc: false,
      options: {},
      pagination: {},
      selectedDepot: null,
      selectedDepotForSubTable: [],
      return_request_menu: false,
      return_request_date: null,
      nowDate: new Date().toISOString().slice(0, 10),
      confirmationDialog: false,
      confirmationDialogConfirmationText: null,
      confirmationDialogFalseText: null,
      confirmationDialogTrueText: null,
      confirmationDialogButtonClickedIs: null,
      confirmationDialogOperation: null,
      lastDepotSelected: null,
    };
  },
  mounted() {
  },
  watch: {
    value:{
        handler: function(val){
            this.internalVisible = val;
            if(val){
                this.initData();
            }
        },
        immediate: true
    },
    internalVisible(val) {
      this.$emit("input", val);
    },
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal == true && this.confirmationDialogOperation != null) {
        if (
          this.confirmationDialogOperation == "add_to_document" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.addToDocument(this.selectedDepot);
        }
        this.confirmationDialog = false;
        this.confirmationDialogButtonClickedIs = null;
      }
    },
  },
  methods: {
    initData(){
        this.autocompleteValueLocal = this.autocompleteValue();
        this.header = { Authorization: "Bearer " + this.token };
        this.confirmationDialog = false;
        this.confirmationDialogConfirmationText = null;
        this.confirmationDialogReCheckBoxConfirmationText = null;
        this.confirmationDialogFalseText = null;
        this.confirmationDialogTrueText = null;
        this.confirmationDialogButtonClickedIs = null;
        this.confirmationDialogOperation = null;

        this.fetchData();
    },
    close() {
      this.$emit("input", false);
    },
    fetchData(currentPage = null) {
      if (!currentPage) {
        this.options.page = 1;
        // this.resetDataTable(currentPage);
      }
      
      this.isLoading = true;
      const payload = {
        page: this.page,
        items_per_page: this.itemsPerPage,
        order_by: this.sortBy,
        order_direction: this.sortOrd,
        search: this.search,
      };
      axios({
        method: "get",
        url: API_BASE_URL + "/depots?expired=1&vehicle_id=" + this.vehicle_id,
        headers: this.header,
        params: payload,
      })
        .then((data) => {
          this.expiredDepots = data.data.data;
          //   this.expiredDepots.forEach((vehicle) => {
          //     vehicle.is_leasing = vehicle.is_leasing == 1 ? true : false;
          //   });
          this.totalItems = data.data.total;
          this.isLoading = false;
          if(this.expiredDepots && this.expiredDepots.length > 0){
            this.selectDepot(this.expiredDepots[0]);
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$toast.success(
            this.$t("vehicle.something_went_wrong_while_fetching_data")
          );
        });
    },


    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    addItToDocument() {
        this.confirmationDialogConfirmationText = this.$t(
            "expired_depots.extend_confirmation"
        );
        this.confirmationDialogFalseText = this.$t("articles.cancel");
        this.confirmationDialogTrueText = this.$t("yes");
        this.confirmationDialogOperation = "add_to_document";
        this.confirmationDialog = true;
    },
    addToDocument(depot){
        this.$emit("addDepotToDocument", depot);
        this.close();
    },
    debounceInput: _.debounce(function () {
      if (this.isDebounceCancelled) {
        this.isDebounceCancelled = false;
        return false;
      }
      this.fetchData();
    }, 500),
    updateLocalStorage() {
      let filters = {
        items_per_page: this.itemsPerPage,
        sortBy: this.sortBy,
        sortOrd: this.sortOrd,
        search: this.search ?? "",
      };
      localStorage.setItem(
        "EXPIRED_DEPOT_LISTING_FILTERS",
        JSON.stringify(filters)
      );
    },
    applyPreviousFilters() {
      return new Promise((resolve) => {
        let clientFilters = JSON.parse(
          localStorage.getItem("EXPIRED_DEPOT_LISTING_FILTERS")
        );

        if (clientFilters != null) {
          this.itemsPerPage = clientFilters.items_per_page;
          this.sortBy = clientFilters.sortBy;
          this.sortOrd = clientFilters.sortOrd;
          this.search = clientFilters.search;
        }
        return resolve();
      });
    },
    getLocalisationFromDepot(item) {
      let localisation = "";
      let activeDepot = 0;
      if (item.depot) {
        item.depot.forEach((element) => {
          if (element.status_id == 10171001 && element.deleted_at == null) {
            // depot stored
            activeDepot++;
            localisation += element.localisation
              ? " " + element.localisation + ","
              : "";
          }
        });
        if (activeDepot > 0 && !localisation.trim()) {
          return this.$t("yes");
        } else if (activeDepot > 0 && localisation.trim()) {
          return localisation.slice(0, -1);
        } else {
          return "";
        }
      }
    },
    highlightRow(itemId) {
      this.$nextTick(() => {
        if (
          document.getElementsByClassName("tyre-depot-matched-row").length > 0
        ) {
          document
            .getElementsByClassName("tyre-depot-matched-row")[0]
            .classList.remove("tyre-depot-matched-row");
        }
        document.getElementById(itemId).parentElement.parentElement.className =
          "tyre-depot-matched-row";
      });
    },
    selectDepot(row) {
      this.selectedDepot = row;

      row.details.forEach((detail) => {
        detail.checked = true;
      });
      this.selectedDepotForSubTable = row.details;
    },
    checkIfSomeErrorInDepot(depotDetails) {
      let isError = false;
      depotDetails.forEach((rowdepot) => {
        if (
          rowdepot.article_status &&
          rowdepot.article_status.key == "damaged"
        ) {
          isError = true;
        }
      });
      return isError;
    },
    closeTyreDialog() {
      this.modify_stock_dialog = false;
      this.$emit("modifyClose", false, false);
    },
    saveTyreDialog() {
      this.modify_stock_dialog = false;
      this.$emit("modifyClose", false, this.selectedDepot);
    },
  },
  computed: {
    depositHeader() {
      return [
        {
          text: " ",
          align: "start",
          sortable: false,
          value: "checkbox",
          width: "10",
        },
        {
          text: this.$t("tyre_hotel.deposit.status"),
          align: "start",
          sortable: false,
          value: "status",
          width: "15%",
        },
        {
          text: this.$t("tyre_hotel.deposit.localized"),
          align: "start",
          sortable: false,
          value: "localisation",
          width: "15%",
        },
        {
          text: this.$t("tyre_hotel.deposit.entry_date"),
          align: "start",
          sortable: false,
          value: "created_at",
          width: "15%",
        },
        {
          text: this.$t("expired_depots.expiry_date"),
          value: "expiration_date",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$t("tyre_hotel.deposit.return_request_date"),
          align: "start",
          sortable: false,
          value: "requested_out_for",
          width: "15%",
        },
        {
          text: this.$t("tyre_hotel.deposit.exit_date"),
          align: "start",
          sortable: false,
          value: "deleted_at",
          width: "10%",
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "someerrors",
          width: "10%",
        },
      ];
    },
    depositDeatilsHeader() {
      return [
        {
          text: " ",
          align: "start",
          sortable: false,
          value: "checkbox",
          width: "10",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.position"),
          align: "start",
          sortable: false,
          value: "position",
          width: "50",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.profile"),
          align: "start",
          sortable: false,
          value: "article",
          width: "350",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.width"),
          align: "start",
          sortable: false,
          value: "article_width",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.height"),
          align: "start",
          sortable: false,
          value: "article_height",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.rim"),
          align: "start",
          sortable: false,
          value: "article_rim",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.li"),
          align: "start",
          sortable: false,
          value: "article_li",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.si"),
          align: "start",
          sortable: false,
          value: "article_si",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.mm"),
          align: "start",
          sortable: false,
          value: "mm",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.tightening_torque"),
          align: "start",
          sortable: false,
          value: "couple",
          width: "150",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.pressure"),
          align: "start",
          sortable: false,
          value: "pressure",
          width: "5",
        },
        {
          text: this.$t("articles.dot"),
          align: "start",
          sortable: false,
          value: "dot",
          width: "5",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.rim_type"),
          align: "start",
          sortable: false,
          value: "rim_type",
          width: "100",
        },
        {
          text: this.$t("tyre_hotel.deposit_details.with_enjo"),
          align: "start",
          sortable: false,
          value: "with_enjo",
          width: "5",
        },
        // { text: this.$t('tyre_hotel.deposit_details.alu'),              align: 'start',     sortable: false, value:'alu', width:'5' },
      ];
    },
  },
};
</script>
